import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementECReceiptDetailContainer } from "@/components/features/management/EC-sales/detail/ui/components";

import { useConfirmParams } from "./hooks";

export const ManagementECReceiptDetailPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID, ecID } = result;

	return (
		<PageMeta title="ECの詳細" url={generatePath(PATHS.HOTEL.MANAGEMENT.EC_SALES.DETAIL, { hotelID, ecID })}>
			<ManagementECReceiptDetailContainer hotelID={hotelID} receiptID={ecID} />
		</PageMeta>
	);
};

ManagementECReceiptDetailPage.displayName = "ManagementECReceiptDetailPage";
